import gql from 'graphql-tag'

export default gql`
query ListScheduleTask($params: ListQueryArgs, $filter: AutomationTaskFilterInput) {
  cashAssist {
    listScheduleTask(params: $params, filter: $filter) {
      cursors {
        after
        before
        hasNext
      }
      items {
        taskType
        taskName
        id: taskId
        taskId
        additonalInfo {
          lastExecutedAt
        }
        nextExecution
        scheduleCron
        isActive
        targetLambdaPayload {
          ... on EmailClosingPayload {
            emailCashRegisterIds: cashRegisterIds
            daysBack
            email
          }
          ... on AutoClosingPayload {
            autoCashRegisterIds: cashRegisterIds
          }
        }
      }
    }
  }
}
`
